import { useEffect, useState } from "react"

const UiSpinner = ({color}) => {

	const [showReload, setShowReload] = useState(false)

	const pageReload = (e) => {
		e.preventDefault()
		window.location.reload()
	}

	useEffect(() => {
		setTimeout(() => {
			setShowReload(true)
		}, 50000)
	}, [])


	return (
		<div className="d-flex  flex-column justify-content-center align-self-center">
			<div className={"spinner-border text-secondary  align-self-center text-"+color} role="status">
				<span className="visually-hidden">Loading...</span>
			</div>
			{showReload && <a href="#" className="poppins" onClick={pageReload}>reload</a>}
		</div>
		

	)
}

export default UiSpinner